import { initializeApp, getApps } from 'firebase/app';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY ?? 'AIzaSyDeAZvJfjh0phln4tXpU3PJpQkmrADQkTU',
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN ?? 'odus-24326.firebaseapp.com',
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID ?? 'odus-24326',
  storageBucket:
    process.env.REACT_APP_FIREBASE_STORAGE_BUCKET ?? 'odus-24326.firebasestorage.app',
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID ?? '90756632120',
  appId: process.env.REACT_APP_FIREBASE_APP_ID ?? '1:90756632120:web:6b668aab8ef4ad7a3e20cd',
};

const app = getApps().length ? getApps()[0] : initializeApp(firebaseConfig);

export { app, firebaseConfig };
